import { ComponentType } from '@angular/cdk/portal';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  Inject,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { UIListFilters } from '../filters/filters';

interface FilterDialogData<T> {
  mobileFilters?: ComponentType<T> & UIListFilters<T>;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  // tslint:disable-next-line:component-selector
  selector: 'ui-filter-dialog',
  styleUrls: ['./filter-dialog.component.scss'],
  templateUrl: './filter-dialog.component.html',
})
export class FilterDialogComponent<T> implements OnDestroy {

  private readonly unsubscription$ = new Subject();

  private readonly mobileFilterContainer$ = new BehaviorSubject<ViewContainerRef | undefined>(undefined);
  @ViewChild('mobileFilterRef', { read: ViewContainerRef, static: true }) set mobileFilterContainer(v: undefined | ViewContainerRef) {
    this.mobileFilterContainer$.next(v);
  }

  realFilterComponentRef?: ComponentRef<any>;

  constructor(
    private readonly resolver: ComponentFactoryResolver,
    private readonly dialogRef: MatDialogRef<any>,
    private readonly cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public readonly data: FilterDialogData<T>,
  ) {

    this.mobileFilterContainer$.pipe(
      filter((mobileFilterContainer): mobileFilterContainer is ViewContainerRef => !!mobileFilterContainer),
      takeUntil(this.unsubscription$),
    ).subscribe((mobileFilterContainer) => {
      if (
        !this.data ||
        !this.data.mobileFilters ||
        (this.data && this.data.mobileFilters && this.data.mobileFilters.hasOwnProperty('data'))
      ) {
        throw new Error('Cannot use this UI dialog component without implementig related interfaces as documented');
      }

      const factory: ComponentFactory<any> = this.resolver.resolveComponentFactory(this.data.mobileFilters);

      mobileFilterContainer.clear();

      this.realFilterComponentRef = mobileFilterContainer.createComponent(factory);
    });
  }

  ngOnDestroy() {
    this.unsubscription$.next(null);
    this.unsubscription$.complete();
  }

  closeHandler() {
    this.dialogRef.close();
  }

  applyHandler() {
    if (
      !this.realFilterComponentRef ||
      (this.realFilterComponentRef && this.realFilterComponentRef.instance.hasOwnProperty('data'))
    ) {
      throw new Error('Cannot use this UI dialog component without implementig related interfaces as documented');
    }

    this.dialogRef.close(this.realFilterComponentRef.instance.data);
  }
}
